import { warn } from '@execonline-inc/logging';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { Task } from 'taskarian';
import { callApi } from '../../../../Appy';
import { emptyFragment } from '../../../../EmptyFragment';
import { SearchParameter, SearchParameters } from '../../../../ListFilter/Types';
import { Link } from '../../../../Resource/Types';
import { TPlainTextKey } from '../../../../Translations';
import GenericSortFilter from '../../../GenericSortFilter';
import { FilterError, State, error, loading, ready } from './Types';
import { filterOptionsResourceDecoder } from '../OrganizationFilter/OrganizationFilterTypeahead/UseOrganizationFilterTypeahead/Decoder';

interface Props {
  link: Link;
  updatingSearchParameters: (searchParameter: SearchParameter) => void;
  searchParameters: SearchParameters;
  labelText: TPlainTextKey;
  filterKey: string;
}

const fetchOptions = (link: Link) =>
  Task.succeed<FilterError, Link>(link).andThen(callApi(filterOptionsResourceDecoder, {}));

function GenericSideLoadFilter({
  link,
  labelText,
  filterKey,
  updatingSearchParameters,
  searchParameters,
}: Props) {
  const [state, setState] = useState<State>(loading);

  useEffect(() => {
    fetchOptions(link).fork(
      (e) => {
        warn('Options failed to load', e);
        return setState(error);
      },
      (resource) => setState(ready(resource)),
    );
  }, [link]);

  switch (state.kind) {
    case 'error':
      return emptyFragment();
    case 'loading':
      return (
        <div className="mr-4 w-2/6">
          <GenericSortFilter
            labelText={labelText}
            options={[{ value: 'all', label: 'All' }]}
            parameters={searchParameters}
            updatingParameters={updatingSearchParameters}
            sortFilterKey={filterKey}
          />
        </div>
      );
    case 'ready':
      return (
        <div className="mr-4 w-2/6">
          <GenericSortFilter
            labelText={labelText}
            options={state.resource.payload}
            parameters={searchParameters}
            updatingParameters={updatingSearchParameters}
            sortFilterKey={filterKey}
          />
        </div>
      );
  }
}

export default observer(GenericSideLoadFilter);
